module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coordinators-wrapper"
  }, [_c('div', {
    staticClass: "coordinators-box"
  }, [_vm._l((_vm.items), function(item, index) {
    return [_c('CoordinatorElement', {
      key: index,
      attrs: {
        "item": item
      }
    })]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9030aa2","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/footer/coordinators/CoordinatorsBox.vue
// module id = 44002ba8ab0081b1b8e1
// module chunks = 0